const Cite = require('citation-js')

function yearComparison(citA, citB) {
    if( citA.issued == undefined)
        return -1
    if( citB.issued == undefined)
        return 1
    return citB.issued['date-parts'][0][0] - citA.issued['date-parts'][0][0]
}

export function getBibliography(bibtext, format) {
    const pubs = new Cite(bibtext).format('data', {format: 'object'});
    pubs.sort(yearComparison)
    let references = []
    pubs.forEach( cite_obj => references.push([new Cite(cite_obj).format('bibliography', {template: format}), cite_obj.id]) ) 
    return references;
}

